import React, { useEffect } from 'react';
import AOS from 'aos';
import Slider from 'react-slick';
import 'aos/dist/aos.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const About = () => {
    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
            offset: 100,
            easing: 'ease-out-cubic',
        });
    }, []);

    // Slider settings
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        pauseOnHover: true,
    };
    return (
        <>
            <div 
                className="container-fluid page-header py-5" 
                style={{ marginBottom: "6rem" }}
                data-aos="fade-down"
            >
                <div className="container py-5">
                    <h1 className="display-3 text-white mb-3">Why Us?</h1>
                </div>
            </div>
            {/* FIXED: First image section with badge */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div 
                            className="col-lg-6"
                            data-aos="fade-right"
                            data-aos-delay="100"
                        >
                            <div className="position-relative">
                                {/* FIX: Added responsive container and responsive image */}
                                <div className="ratio ratio-16x9">
                                    <img
                                        className="img-fluid rounded-lg shadow-lg object-fit-cover"
                                        src="img/company-story.jpeg"
                                        alt="A2Z Solutions company story"
                                    />
                                </div>
                                <div className="position-absolute bottom-0 start-0 bg-primary text-white p-3 p-md-4 rounded-end"
                                    style={{ transform: "translateY(50%)" }}>
                                    {/* Add content here if needed */}
                                </div>
                            </div>
                        </div>

                        {/* ... Rest of content column stays exactly the same ... */}
                        <div 
                            className="col-lg-6"
                            data-aos="fade-left"
                            data-aos-delay="100"
                        >
                            <h6 className="text-primary text-uppercase mb-2">Our Journey</h6>
                            <h1 className="display-6 mb-4">From Local Expertise to Trusted Solutions Provider</h1>
                            <p className="mb-4">Founded in the heart of Mysuru, A2Z Solutions began with a simple vision: to provide
                                reliable, practical support services that help local businesses and healthcare providers focus
                                on their core operations while we handle their critical support functions.</p>

                            <p className="mb-4">Our journey started with a focus on medical billing support for local clinics in
                                Mysuru, recognizing the need for specialized administrative support in the healthcare sector. As
                                we demonstrated our commitment to accuracy and reliability, we expanded our service portfolio to
                                meet the growing needs of the regional business community.</p>

                            <p className="mb-4">Over the years, we have systematically grown our capabilities to include data
                                annotation and entry services, addressing the increasing demand for precise data processing in
                                various industries. Our commitment to quality led us to achieve ISO 9001:2015 certification,
                                demonstrating our dedication to maintaining high standards in all our service delivery
                                processes.</p>

                            <p className="mb-4">Our growth journey has been marked by meaningful collaborations, including our work
                                with institutional partners like KEONICS. These engagements have allowed us to expand our
                                service reach across Karnataka while maintaining our core values of reliability, accuracy, and
                                customer-centric service delivery.</p>

                            <p className="mb-4">Today, A2Z Solutions stands as a trusted partner for businesses across multiple
                                sectors, providing comprehensive support services that enable organizations to operate more
                                efficiently and focus on their core competencies while we handle their critical support
                                functions with precision and professionalism.</p>

                            <div className="row g-4 mt-4">
                                <div 
                                    className="col-sm-6"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    <div className="d-flex">
                                        <i className="fa fa-check-circle text-primary fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Quality Certified</h5>
                                            <p className="mb-0">ISO 9001:2015 Standards</p>
                                        </div>
                                    </div>
                                </div>
                                <div 
                                    className="col-sm-6"
                                    data-aos="fade-up"
                                    data-aos-delay="300"
                                >
                                    <div className="d-flex">
                                        <i className="fa fa-users text-primary fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Expert Team</h5>
                                            <p className="mb-0">25+ Trained Professionals</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            

            <div className="container-fluid py-5 bg-light">
                <div className="container py-5">
                    <div 
                        className="text-center"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        <h6 className="text-primary text-uppercase mb-2">Our Purpose</h6>
                        <h1 className="display-6 mb-5">Mission, Vision & Values</h1>
                    </div>

                    <div 
                        className="mission-statement mb-5"
                        data-aos="fade-up"
                        data-aos-delay="200"
                    >
                        <div className="row align-items-center">
                            <div className="col-lg-8">
                                <h2 className="mb-3">"Empowering businesses with reliable support solutions that drive efficiency
                                    and growth."</h2>
                                <p className="mb-0">We believe that behind every successful business is a team of dedicated
                                    professionals supported by efficient processes.</p>
                            </div>
                            <div className="col-lg-4 text-center">
                                <i className="fas fa-bullseye fa-5x opacity-25"></i>
                            </div>
                        </div>
                    </div>

                    <div className="row g-4 mt-5">
                        <div 
                            className="col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            <div className="value-card p-4 text-center">
                                <div className="value-icon">
                                    <i className="fas fa-eye"></i>
                                </div>
                                <h4 className="mb-3">Our Vision</h4>
                                <p className="mb-0">To become Karnataka's most trusted business support partner, recognized for
                                    reliability, accuracy, and exceptional service delivery across all our offerings.</p>
                            </div>
                        </div>
                        <div 
                            className="col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="400"
                        >
                            <div className="value-card p-4 text-center">
                                <div className="value-icon">
                                    <i className="fas fa-rocket"></i>
                                </div>
                                <h4 className="mb-3">Our Mission</h4>
                                <p className="mb-0">To provide comprehensive, high-quality support services that enable healthcare
                                    providers and businesses to operate more efficiently, reduce overheads, and focus on their
                                    core competencies.</p>
                            </div>
                        </div>
                        <div 
                            className="col-lg-4"
                            data-aos="fade-up"
                            data-aos-delay="500"
                        >
                            <div className="value-card p-4 text-center">
                                <div className="value-icon">
                                    <i className="fas fa-heart"></i>
                                </div>
                                <h4 className="mb-3">Our Values</h4>
                                <p className="mb-0">Integrity, Accuracy, Confidentiality, Timeliness, and Customer-Centric Approach
                                    guide every project we undertake and every client relationship we build.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <div 
                        className="text-center"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        <h6 className="text-primary text-uppercase mb-2">Recognition</h6>
                        <h1 className="display-6 mb-5">Awards & Certifications</h1>
                        <p className="mb-5">Our commitment to quality and excellence is validated through industry certifications
                            and institutional collaborations.</p>
                    </div>

                    {/* ISO Certificate 1 Section */}
                    <div className="container-xxl py-5">
                        <div className="container">
                            <div className="row g-5 align-items-center">
                                <div 
                                    className="col-lg-6"
                                    data-aos="fade-right"
                                    data-aos-delay="200"
                                >
                                    <div className="position-relative h-100">
                                        <img
                                            className="img-fluid rounded-lg shadow-lg"
                                            src="img/iso-certificate.jpg"
                                            style={{ height: "500px", objectFit: "cover" }}
                                            alt="ISO Certificate"
                                        />
                                        <div className="position-absolute bottom-0 start-0 bg-primary text-white p-4 rounded-end"
                                            style={{ transform: "translateY(50%)" }}>
                                            {/* Add content here if needed */}
                                        </div>
                                    </div>
                                </div>
                                <div 
                                    className="col-lg-6"
                                    data-aos="fade-left"
                                    data-aos-delay="300"
                                >
                                    <h6 className="text-primary text-uppercase mb-2">Our Journey</h6>
                                    <h1 className="display-6 mb-4">From Local Expertise to Trusted Solutions Provider</h1>
                                    <p className="mb-4">Founded in the heart of Mysuru, A2Z Solutions began with a simple vision: to
                                        provide reliable, practical support services that help local businesses and healthcare
                                        providers focus on their core operations while we handle their critical support
                                        functions.</p>

                                    <div className="timeline mb-5">
                                        <div 
                                            className="timeline-item"
                                            data-aos="fade-up"
                                            data-aos-delay="400"
                                        >
                                            <div className="timeline-dot"></div>
                                            <h5>Certificate Issuance</h5>
                                            <p className="mb-0">Issued by Royal Assessments Pvt. Ltd., a member of International
                                                Accreditation Forum (IAF) with global recognition.</p>
                                        </div>
                                        <div 
                                            className="timeline-item"
                                            data-aos="fade-up"
                                            data-aos-delay="500"
                                        >
                                            <div className="timeline-dot"></div>
                                            <h5>Certification Standard</h5>
                                            <p className="mb-0">ISO 9001:2015 - Quality Management Systems certification
                                                demonstrating commitment to quality processes.</p>
                                        </div>
                                        <div 
                                            className="timeline-item"
                                            data-aos="fade-up"
                                            data-aos-delay="600"
                                        >
                                            <div className="timeline-dot"></div>
                                            <h5>Scope of Certification</h5>
                                            <p className="mb-0">Covers IT Education & Services, IT infrastructure supply, manpower
                                                supply, furniture supply, solar solutions, CCTV & electrical works, and digital
                                                solutions.</p>
                                        </div>
                                        <div 
                                            className="timeline-item"
                                            data-aos="fade-up"
                                            data-aos-delay="700"
                                        >
                                            <div className="timeline-dot"></div>
                                            <h5>Validity Period</h5>
                                            <p className="mb-0">Certification valid from October 6, 2024 to October 5, 2026 with
                                                regular surveillance audits.</p>
                                        </div>
                                    </div>

                                    <div className="row g-4">
                                        <div 
                                            className="col-sm-6"
                                            data-aos="fade-up"
                                            data-aos-delay="800"
                                        >
                                            <div className="d-flex">
                                                <i className="fa fa-check-circle text-primary fa-2x flex-shrink-0 me-3"></i>
                                                <div>
                                                    <h5 className="mb-1">Quality Certified</h5>
                                                    <p className="mb-0">ISO 9001:2015 Standards</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div 
                                            className="col-sm-6"
                                            data-aos="fade-up"
                                            data-aos-delay="900"
                                        >
                                            <div className="d-flex">
                                                <i className="fa fa-users text-primary fa-2x flex-shrink-0 me-3"></i>
                                                <div>
                                                    <h5 className="mb-1">Expert Team</h5>
                                                    <p className="mb-0">25+ Trained Professionals</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ISO Certificate 2 Section */}
                    <div className="container-xxl py-5">
                        <div className="container">
                            <div className="row g-5 align-items-center">
                                <div 
                                    className="col-lg-6"
                                    data-aos="fade-right"
                                    data-aos-delay="200"
                                >
                                    <h6 className="text-primary text-uppercase mb-2">Our Commitment</h6>
                                    <h1 className="display-6 mb-4">Certified Excellence in Information Security</h1>
                                    <p className="mb-4">
                                        At A2Z Solutions, we understand that trust is the foundation of every successful partnership.
                                        That's why we've invested in achieving internationally recognized certifications that validate
                                        our commitment to quality, security, and professional excellence.
                                    </p>

                                    <p className="mb-4">
                                        Our ISO 27001:2022 certification for Information Security Management Systems demonstrates
                                        our serious approach to protecting client data and maintaining confidentiality across all
                                        our service operations. This certification is not just a badge—it's a promise to our clients
                                        that their information is handled with the highest standards of security and care.
                                    </p>

                                    <p className="mb-4">
                                        Beyond information security, we also maintain ISO 9001:2015 certification for Quality Management,
                                        ensuring consistent service delivery and continuous improvement in all our processes. These
                                        certifications work together to provide our clients with peace of mind, knowing they're
                                        partnering with a company that prioritizes both quality and security.
                                    </p>

                                    <p className="mb-4">
                                        Whether it's medical billing data, client training materials, or proprietary business
                                        information, our certified systems ensure that every piece of data we handle is protected
                                        according to global best practices. This commitment extends across all our services—from
                                        IT education to hardware solutions and manpower services.
                                    </p>

                                    <div className="row g-4 mt-4">
                                        <div 
                                            className="col-sm-6"
                                            data-aos="fade-up"
                                            data-aos-delay="300"
                                        >
                                            <div className="d-flex align-items-start">
                                                <i className="fa fa-shield-alt text-primary fa-2x flex-shrink-0 me-3"></i>
                                                <div>
                                                    <h5 className="mb-1">Information Security</h5>
                                                    <p className="mb-0">ISO 27001 Certified Systems</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div 
                                            className="col-sm-6"
                                            data-aos="fade-up"
                                            data-aos-delay="400"
                                        >
                                            <div className="d-flex align-items-start">
                                                <i className="fa fa-check-circle text-primary fa-2x flex-shrink-0 me-3"></i>
                                                <div>
                                                    <h5 className="mb-1">Quality Management</h5>
                                                    <p className="mb-0">ISO 9001 Certified Processes</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div 
                                    className="col-lg-6"
                                    data-aos="fade-left"
                                    data-aos-delay="200"
                                >
                                    <div className="position-relative h-100 d-flex align-items-center justify-content-center">
                                        <div className="certificate-container position-relative w-100">
                                            <img
                                                className="img-fluid rounded-lg shadow-lg w-100"
                                                src="img/iso-certificate-2.png"
                                                style={{
                                                    maxHeight: "500px",
                                                    objectFit: "contain",
                                                    border: "1px solid #e9ecef",
                                                    backgroundColor: "#ffffff"
                                                }}
                                                alt="ISO 27001:2022 Information Security Management Certification"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* GDPR Compliance Section */}
                    <div className="container-xxl py-5">
                        <div className="container">
                            <div className="row g-5 align-items-center">
                                <div 
                                    className="col-lg-6"
                                    data-aos="fade-right"
                                    data-aos-delay="200"
                                >
                                    <div className="position-relative h-100">
                                        <img
                                            className="img-fluid rounded-lg shadow-lg"
                                            src="img/GDPR_certificate.png"
                                            style={{ height: "600px", objectFit: "cover" }}
                                            alt="GDPR Certified - A2Z Solutions"
                                        />
                                        <div className="position-absolute bottom-0 start-0 bg-primary text-white p-3 rounded-end"
                                            style={{ transform: "translateY(50%)" }}>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div 
                                    className="col-lg-6"
                                    data-aos="fade-left"
                                    data-aos-delay="300"
                                >
                                    <h6 className="text-primary text-uppercase mb-2">Data Protection</h6>
                                    <h1 className="display-6 mb-4">GDPR Compliant Services</h1>
                                    <p className="mb-4">A2Z Solutions is proudly GDPR certified, demonstrating our commitment to protecting personal data and maintaining the highest standards of data privacy and security in all our operations.</p>

                                    <div className="mb-4">
                                        <div 
                                            className="d-flex mb-3"
                                            data-aos="fade-up"
                                            data-aos-delay="400"
                                        >
                                            <i className="fa fa-shield-alt text-primary fa-lg mt-1 me-3"></i>
                                            <div>
                                                <h5>Certified Data Protection</h5>
                                                <p className="mb-0">Our management system is certified GDPR compliant, ensuring your data is handled with the utmost care and security.</p>
                                            </div>
                                        </div>
                                        
                                        <div 
                                            className="d-flex mb-3"
                                            data-aos="fade-up"
                                            data-aos-delay="500"
                                        >
                                            <i className="fa fa-check-circle text-primary fa-lg mt-1 me-3"></i>
                                            <div>
                                                <h5>Comprehensive Coverage</h5>
                                                <p className="mb-0">Certification covers all our services including IT solutions, manpower supply, solar installations, CCTV systems, and digital services.</p>
                                            </div>
                                        </div>
                                        
                                        <div 
                                            className="d-flex mb-4"
                                            data-aos="fade-up"
                                            data-aos-delay="600"
                                        >
                                            <i className="fa fa-globe text-primary fa-lg mt-1 me-3"></i>
                                            <div>
                                                <h5>International Standards</h5>
                                                <p className="mb-0">Meeting global data protection regulations to serve clients with confidence and compliance.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row g-3 mb-4">
                                        <div 
                                            className="col-md-6"
                                            data-aos="fade-up"
                                            data-aos-delay="700"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="bg-primary rounded-circle p-2 me-3">
                                                    <i className="fa fa-user-lock text-white"></i>
                                                </div>
                                                <div>
                                                    <h6 className="mb-0">Data Privacy</h6>
                                                    <small>Protected Information</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div 
                                            className="col-md-6"
                                            data-aos="fade-up"
                                            data-aos-delay="800"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div className="bg-primary rounded-circle p-2 me-3">
                                                    <i className="fa fa-certificate text-white"></i>
                                                </div>
                                                <div>
                                                    <h6 className="mb-0">Certified</h6>
                                                    <small>Formally Assessed</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* KEONICS Collaboration */}
                    <div className="row g-5 mt-5 align-items-center">
                        <div 
                            className="col-lg-6"
                            data-aos="fade-right"
                            data-aos-delay="200"
                        >
                            <h3 className="mb-4">Institutional Collaboration with KEONICS</h3>
                            <p className="mb-4">Our collaboration with Karnataka State Electronics Development Corporation Limited
                                (KEONICS) represents a significant milestone in our journey. KEONICS, established in 1976 and
                                ISO 9001:2015 certified, is a government organization dedicated to promoting electronics and IT
                                infrastructure across Karnataka.</p>

                            <div 
                                className="d-flex mb-3"
                                data-aos="fade-up"
                                data-aos-delay="300"
                            >
                                <i className="fas fa-check-circle text-primary me-3 mt-1"></i>
                                <div>
                                    <h6>Training Program Support</h6>
                                    <p className="mb-0">Conducted practical IT training sessions for 500+ participants across
                                        KEONICS centers in Mysuru and surrounding districts.</p>
                                </div>
                            </div>

                            <div 
                                className="d-flex mb-3"
                                data-aos="fade-up"
                                data-aos-delay="400"
                            >
                                <i className="fas fa-check-circle text-primary me-3 mt-1"></i>
                                <div>
                                    <h6>Data Processing Projects</h6>
                                    <p className="mb-0">Managed confidential data annotation and processing for pilot e-governance
                                        initiatives with 99.8% accuracy rate.</p>
                                </div>
                            </div>

                            <div 
                                className="d-flex"
                                data-aos="fade-up"
                                data-aos-delay="500"
                            >
                                <i className="fas fa-check-circle text-primary me-3 mt-1"></i>
                                <div>
                                    <h6>Hardware Deployment</h6>
                                    <p className="mb-0">Supplied and configured computer hardware for 25+ training labs and
                                        government offices across South Karnataka.</p>
                                </div>
                            </div>
                        </div>
                        <div 
                            className="col-lg-6"
                            data-aos="fade-left"
                            data-aos-delay="200"
                        >
                            <img
                                src="img/franchise-certificate.png"
                                className="img-fluid rounded shadow-lg"
                                style={{
                                    height: "auto",
                                    maxHeight: "500px",
                                    width: "100%",
                                    maxWidth: "100%",
                                    objectFit: "contain"
                                }}
                                alt="A2Z Solutions KEONICS Partnership"
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="text-center">
            <h1
                className="display-6 mb-5"
                data-aos="fade-up"
                data-aos-delay="100"
            >
                    Our Institution
            </h1>
            </div>

            {/* Hero Slider - Only Images */}
            {/* FIXED: Hero Slider - Only Images */}
            {/* Hero Slider - Only Images */}
            <div className="container py-4 position-relative mt-4">
                <Slider {...sliderSettings} className="hero-slider mb-4">
                    <div className="hero-slide">
                        <div className="position-relative">
                            <img
                                className="img-fluid rounded shadow"
                                src="img/aboutcar-1.jpeg"
                                alt="A2Z Solutions Services"
                                style={{ height: "500px", width: "100%", objectFit: "cover" }}
                            />
                        </div>
                    </div>

                    <div className="hero-slide">
                        <div className="position-relative">
                            <img
                                className="img-fluid rounded shadow"
                                src="img/aboutcar-2.jpeg"
                                alt="A2Z Solutions Services"
                                style={{ height: "500px", width: "100%", objectFit: "cover" }}
                            />
                        </div>
                    </div>

                    <div className="hero-slide">
                        <div className="position-relative">
                            <img
                                className="img-fluid rounded shadow"
                                src="img/aboutcar-3.jpeg"
                                alt="A2Z Solutions Support"
                                style={{ height: "500px", width: "100%", objectFit: "cover" }}
                            />
                        </div>
                    </div>

                    <div className="hero-slide">
                        <div className="position-relative">
                            <img
                                className="img-fluid rounded shadow"
                                src="img/aboutcar-4.jpeg"
                                alt="A2Z Solutions Business Support"
                                style={{ height: "500px", width: "100%", objectFit: "cover" }}
                            />
                        </div>
                    </div>
                </Slider>
            </div>

            <div className="container-fluid py-5">
                <div className="container py-5 text-center">
                    <div className="row justify-content-center">
                        <div 
                            className="col-lg-8"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            <h1 className="display-6 mb-4">Ready to Streamline Your Operations?</h1>
                            <p className="mb-4">Join 250+ businesses and healthcare providers who trust A2Z Solutions for reliable
                                support services. Let's discuss how we can help your organization operate more efficiently.</p>
                            <a 
                                href="/contact" 
                                className="btn btn-primary py-3 px-5 me-3"
                                data-aos="zoom-in"
                                data-aos-delay="200"
                            >
                                Reach Us
                            </a>
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default About;